import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

/* import Vue from 'vue'
import Vuetify from 'vuetify/lib' */

//import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      dark: true,
      themes: {
        dark: {
          base: "#666",
          primary: "#2564A9",
          secondary: "#EE5320",
          error: '#F62536',
          warning: '#F68325',
          success: '#3AF625',
          info: '#008BFF',
          "lighten-5": "#eceff1",
          "lighten-4": "#cfd8dc",
          "lighten-3": "#b0bec5",
          "lighten-2": "#90a4ae",
          "lighten-1": "#78909c",
          "darken-1": "#546e7a",
          "darken-2": "#455a64",
          "darken-3": "#37474f",
          "darken-4": "#263238",
          "default": "#424242",
          default_dark: "#222222",
          default_light: "#444444",
          primary_dark: "#2564a9",
          primary_light: "#4b8ed8"
        }
      }
    },
    icons: {
      iconfont: 'fa',
      iconfont: 'md'
    }
  });